import React from 'react'
import PropTypes from 'prop-types'
import Wrapper from 'components/Wrapper'
import TeleHealthBottomScreen from '../../TeleHealth/TeleHealthBottomScreen'
import TeleHealthUpperScreen from '../../TeleHealth/TeleHealthUpperScreen'

class AppointmentSessionScreen extends React.Component {

   constructor(props) {
      super(props)
      this.state = {
         isPublisher: false,
         isSubscriber: false,
      };
       this.resetPublisherSubscriberStatus = this.resetPublisherSubscriberStatus.bind(this)
       this.changePublisherStatus = this.changePublisherStatus.bind(this)
       this.changeSubscriberStatus = this.changeSubscriberStatus.bind(this)
       this.getAppointmentCredentials = this.getAppointmentCredentials.bind(this)
       this.getOutsideWrapperProperties = this.getOutsideWrapperProperties.bind(this)
       this.getInsideWrapperProperties = this.getInsideWrapperProperties.bind(this)
   }

   resetPublisherSubscriberStatus() {
      this.setState({ isPublisher: false, isSubscriber: false })
   }
   changePublisherStatus(status) {
      this.setState({ isPublisher: status })
   }
   changeSubscriberStatus(status) {
      this.setState({ isSubscriber: status })
   }
   getAppointmentCredentials() {
      const { appointment, onAccessTeleHealthAppointment } = this.props
      onAccessTeleHealthAppointment(appointment.appointmentId)
   }

   getOutsideWrapperProperties() {
      const outsideWrapperProperties1 = {
         noPaper: true,
         noPadding: true,
         fullWidth: true,
         height: '100%',
         className: 'OutsideWrapper',
         style: {
            // border: '1px solid black',
            height: '100%',
            minHeight: '505px'
         }
      }
      const outsideWrapperProperties2 = {
         className: 'OutsideWrapper',
         noPaper: true,
         noPadding: true,
         fullWidth: true,
      }
      return ((this.state.isSubscriber || this.state.isPublisher) ? outsideWrapperProperties1 : outsideWrapperProperties2)
      // return outsideWrapperProperties1
   }
   getInsideWrapperProperties() {
      const insideWrapperProperties1 = {
         noPaper: false,
         noPadding: false,
         fullWidth: false,
         height: 'calc(100% - 30px)',
         className: 'InsideWrapper',
         style: {
            // border: '1px solid red',
            height: '100%',
            padding: '5px',
            minHeight: '475px',
            position: 'relative'
         }
      }
      const insideWrapperProperties2 = {
         className: 'InsideWrapper',
         noPaper: false,
         noPadding: true,
         fullWidth: false,
      }

      const insideWrapperProperties3 = {
         ...insideWrapperProperties2,
         style: {
            // border: '1px solid blue',
            padding: '5px',
         }
      }
      return ((this.state.isPublisher) ? (this.state.isSubscriber ? insideWrapperProperties1 : insideWrapperProperties3 ): insideWrapperProperties2)
      // return insideWrapperProperties1
   }

   render() {
      const { auth, appointment, ui, teleHealthAppointmentCredentials, clearTelehealthAppointmentCredentials } = this.props
      const outsideWrapperProperties = this.getOutsideWrapperProperties()
      const insideWrapperProperties = this.getInsideWrapperProperties()

      return (
         <Wrapper {...outsideWrapperProperties}>
            <Wrapper {...insideWrapperProperties}>
               <TeleHealthUpperScreen
                  appointment={appointment}
                  ui={ui}
                  teleHealthAppointmentCredentials={teleHealthAppointmentCredentials}
                  getAppointmentCredentials={this.getAppointmentCredentials}
                  resetPublisherSubscriberStatus={this.resetPublisherSubscriberStatus}
                  changePublisherStatus={this.changePublisherStatus}
                  changeSubscriberStatus={this.changeSubscriberStatus}
                  isPublisher={this.state.isPublisher}
                  isSubscriber={this.state.isSubscriber}
                  clearTelehealthAppointmentCredentials={clearTelehealthAppointmentCredentials}
               />
               {this.state.isSubscriber ? null :
                  <TeleHealthBottomScreen
                     appointment={appointment}
                     auth={auth}
                  />
               }
            </Wrapper>
         </Wrapper>
      )
   }
}

AppointmentSessionScreen.propTypes = {
   auth: PropTypes.object.isRequired,
   appointment: PropTypes.object.isRequired,
   onAccessTeleHealthAppointment: PropTypes.func.isRequired,
   clearTelehealthAppointmentCredentials: PropTypes.func.isRequired,
   ui: PropTypes.object.isRequired,
}

export default AppointmentSessionScreen



// WEBPACK FOOTER //
// ./src/components/_Screens/AppointmentSession/index.js